module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 835
// module chunks = 0